import {
  every,
  maxBy,
  sortBy,
  filter,
  findLastIndex,
} from 'lodash';

const sortQuestLevels = (quests) => sortBy(quests, 'levelNumber');

export default function mapQuests(quests) {
  const activeQuests = quests;
  const TASK_TYPES = {
    Rounds: 'questRoundsTaskType',
    Bet: 'questBetTaskType',
    Win: 'questWinTaskType',
    WinBet: 'questWinBetTaskType',
    WinningStreak: 'questWinStreakTaskType',
    LosingStreak: 'questLossStreakTaskType',
    BetRounds: 'questBetRoundsTaskType',
    WinsCount: 'questWinsCountTaskType',
    LossCount: 'questLossCountTaskType',
    WinsRounds: 'questWinsRoundsTaskType',
    WinBetRounds: 'questWinBetRoundsTaskType',
    WinLoss: 'questWinLossTaskType',
  };
  const questLevelsData = [
    {
      name: 'bronze',
      displayName: 'Bronze',
      progressBgColor: 'rgba(0, 0, 0, 0.6)',
      progressAccentColor: '#FFBA19',
      isUnlocked: true,
      completed: false,
    },
    {
      name: 'silver',
      displayName: 'Silver',
      progressBgColor: 'rgba(0, 0, 0, 0.6)',
      progressAccentColor: '#74E6FF',
      isUnlocked: false,
      completed: false,
    },
    {
      name: 'gold',
      displayName: 'Gold',
      progressBgColor: 'rgba(0, 0, 0, 0.6)',
      progressAccentColor: '#FFF156',
      isUnlocked: false,
      completed: false,
    },
  ];

  if (activeQuests.length) {
    activeQuests[0].levels = sortQuestLevels(activeQuests[0].levels);

    // Check the current active levels and unlock the next available
    const completedLevelIndex = findLastIndex(activeQuests[0].levels, (l) => every(l.tasks, (t) => t.isCompleted));
    if (completedLevelIndex !== -1 && completedLevelIndex + 1 < questLevelsData.length) {
      questLevelsData[completedLevelIndex].isUnlocked = true;
      if (questLevelsData[completedLevelIndex + 1]) {
        questLevelsData[completedLevelIndex].isUnlocked = true;
        questLevelsData[completedLevelIndex + 1].isUnlocked = true;
      }
    }

    // Check the final levels state and unlock
    const allCompleted = filter(activeQuests[0].levels, (level) => every(level.tasks, (t) => t.isCompleted));
    if (allCompleted.length === activeQuests[0].levels.length) {
      Object.keys(allCompleted).forEach((key) => {
        questLevelsData[key].isUnlocked = true;
      });
    }

    return activeQuests[0].levels.map((questLevel, index) => {
      const questData = {
        ...questLevelsData[index],
        ...questLevel,
      };
      if (questData) {
        const numOfTasks = questData.tasks.length;
        const completedTasks = questData.tasks.filter((t) => t.isCompleted);
        questData.title = questLevelsData[index].displayName;
        questData.completed = questData.completed || every(questData.tasks, (task) => task.isCompleted);
        questData.isUnlocked = questLevelsData[index].isUnlocked;
        questData.levelName = questLevelsData[index].name;
        questData.tasksCompletion = `${completedTasks.length}/${numOfTasks}`;
        questData.progress = (completedTasks.length / numOfTasks) * 100;
        questData.possibleWin = maxBy(questData?.prizes, (prize) => prize?.amount)?.amount;
        questData.endTime = activeQuests[0].endTime;
        questData.tasks.map((t) => {
          const task = t;
          task.title = TASK_TYPES[task.type];
          if (task.baseBetMultiplier) {
            task.baseBetAmount = activeQuests[0].baseBetAmount;
            task.baseBetMultiplierFactor = activeQuests[0].baseBetMultiplierFactor;
          }
          return task;
        });
      }
      return questData;
    });
  }
  return [];
}
